import axios from 'axios';

import buildPaginationQueryOpts from '@/shared/sort/sorts';

import { ICompanyFlaw } from '@/shared/model/company-flaw.model';
import buildCriteriaQuery from '@/shared/criteria/criterias';
const baseApiUrl = 'api/company-flaws';

export default class CompanyFlawService {
  public find(id: number): Promise<ICompanyFlaw> {
    return new Promise<ICompanyFlaw>((resolve, reject) => {
      axios
        .get(`${baseApiUrl}/${id}`)
        .then(function(res) {
          resolve(res.data);
        })
        .catch(err => {
          reject(err);
        });
    });
  }

  /*
  public retrieve(paginationQuery?: any): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      axios
        .get(baseApiUrl + `?${buildPaginationQueryOpts(paginationQuery)}`)
        .then(function(res) {
          resolve(res);
        })
        .catch(err => {
          reject(err);
        });
    });
  }
*/

  public retrieve(paginationQuery?: any): Promise<any> {
    // bugfix: size to 75 or dosent retrieve all elemenet; if there will same problems increase size
    if (!paginationQuery) {
      paginationQuery = {
        page: 0,
        size: 100,
        sort: []
      };
    }

    return new Promise<any>((resolve, reject) => {
      axios
        .get(baseApiUrl + `?${buildPaginationQueryOpts(paginationQuery)}`)
        .then(function(res) {
          resolve(res);
        })
        .catch(err => {
          reject(err);
        });
    });
  }

  public retrieveByCriteria(paginationQuery?: any, criteriaQuery?: any): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      axios
        .get(baseApiUrl + `?${buildPaginationQueryOpts(paginationQuery)}${buildCriteriaQuery(criteriaQuery)}`)
        .then(function(res) {
          resolve(res);
        })
        .catch(err => {
          reject(err);
        });
    });
  }

  public delete(id: number): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      axios
        .delete(`${baseApiUrl}/${id}`)
        .then(function(res) {
          resolve(res);
        })
        .catch(err => {
          reject(err);
        });
    });
  }

  public create(entity: ICompanyFlaw): Promise<ICompanyFlaw> {
    return new Promise<ICompanyFlaw>((resolve, reject) => {
      axios
        .post(`${baseApiUrl}`, entity)
        .then(function(res) {
          resolve(res.data);
        })
        .catch(err => {
          reject(err);
        });
    });
  }

  public update(entity: ICompanyFlaw): Promise<ICompanyFlaw> {
    return new Promise<ICompanyFlaw>((resolve, reject) => {
      axios
        .put(`${baseApiUrl}`, entity)
        .then(function(res) {
          resolve(res.data);
        })
        .catch(err => {
          reject(err);
        });
    });
  }
}
